<template>
	<div class="container">
		<section>
			<b-modal :active.sync="isNewNoteActive" has-modal-card :canCancel="[]">
				<NewNote
					v-bind:stage="$store.state.property.stage"
					v-bind:propertyId="$store.state.property.id"
				></NewNote>
			</b-modal>

			<b-modal
				:active.sync="$store.state.listing.isActive"
				has-modal-card
				:canCancel="[]"
			>
				<ListingEditor
					v-bind:propertyId="$store.state.property.id"
				></ListingEditor>
			</b-modal>

			<b-modal
				:active.sync="isConnectionSelectActive"
				:width="960"
				:canCancel="[]"
			>
				<ConnectionSelect />
			</b-modal>

			<b-modal
				:active.sync="$store.state.isAddDocumentsActive"
				has-modal-card
				:canCancel="[]"
			>
				<AddDocuments
					v-bind:propertyId="$store.state.property.id"
				></AddDocuments>
			</b-modal>

			<b-modal
				:active.sync="$store.state.isNewMultifamilyEvaluationActive"
				has-modal-card
				:canCancel="[]"
			>
				<NewMultifamily />
			</b-modal>

			<b-modal
				:active.sync="$store.state.isEditMFFPropertyActive"
				has-modal-card
				:canCancel="[]"
			>
				<EditMultifamilyPropertyAttributes />
			</b-modal>

			<div class="card">
				<section class="hero is-primary">
					<div class="hero-body">
						<div class="container">
							<h1 class="title">
								Property Details
							</h1>
						</div>
					</div>
				</section>
			</div>

			<div class="card">
				<div class="card-header">
					<div class="card-header-title">
						Property
					</div>
					<div class="level-right is-small">
						<a @click="goToProperties()">
							<i class="fas fa-arrow-left"></i>
							return to properties&nbsp;&nbsp;
						</a>
					</div>
				</div>
				<div class="card-content">
					<article class="media">
						<figure class="media-left">
							<p class="image is-128x128">
								<img :src="$store.state.property.photoUrl" />
							</p>
						</figure>
						<div class="media-content">
							<div class="content">
								<div class="columns">
									<div class="column">
										<div
											v-if="$store.state.property.propertyType == 'Multifamily'"
										>
											<p class="title" style="margin-bottom: 0em">
												{{
													$store.state.property.multifamilyAttributes
														.propertyName
												}}
												<b-tooltip label="Edit property information">
													<a
														class="fas fa-edit fa-xs"
														@click="editProperty()"
													></a>
												</b-tooltip>
											</p>
											<p>
												<small>{{ $store.state.property.address }}</small
												><br />
												<small
													>{{ $store.state.property.city }},
													{{ $store.state.property.state }}
													{{ $store.state.property.zip }}</small
												>
												<br />
												<small>{{
													$store.state.property.lastUpdate | fromNow
												}}</small>
											</p>
										</div>
										<div
											v-if="
												$store.state.property.propertyType == 'Singlefamily'
											"
										>
											<p>
												<strong class="is-size-4">{{
													$store.state.property.address
												}}</strong
												><br />
												<small
													>{{ $store.state.property.city }},
													{{ $store.state.property.state }}
													{{ $store.state.property.zip }}</small
												>
												<br />
												<small>{{
													$store.state.property.lastUpdate | fromNow
												}}</small>
											</p>
										</div>
									</div>

									<div
										class="column"
										v-if="$store.state.property.propertyType == 'Multifamily'"
									>
										<div class="level">
											<div class="level-item has-text-centered">
												<div>
													<p class="heading">Units</p>
													<p class="subtitle">
														&nbsp;{{
															$store.state.property.multifamilyAttributes.units
														}}&nbsp;
													</p>
												</div>
											</div>
											<div class="level-item has-text-centered">
												<div>
													<p class="heading">Year Built</p>
													<p class="subtitle">
														&nbsp;{{
															$store.state.property.multifamilyAttributes
																.yearBuilt
														}}&nbsp;
													</p>
												</div>
											</div>
											<div class="level-item has-text-centered">
												<div>
													<p class="heading">Class</p>
													<p class="subtitle">
														&nbsp;{{
															$store.state.property.multifamilyAttributes
																.propertyClass
														}}&nbsp;
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</article>
				</div>
			</div>

			<div class="card">
				<div class="card-header">
					<div class="card-header-title">
						Stage
					</div>
				</div>
				<div class="card-content">
					<Stages />
				</div>
			</div>

			<div class="card">
				<div class="card-header">
					<div class="card-header-title">
						Details
					</div>
				</div>

				<div class="card-content">
					<b-tabs v-model="activeTab">
						<b-tab-item label="Evaluations">
							<template slot="header">
								<span
									>Evaluations
									<b-tag rounded>{{ evaluationCount() }}</b-tag></span
								>
							</template>

							<div class="column">
								<div
									class="button is-primary "
									@click="newEvaluation()"
									v-if="$store.state.property.propertyType == 'Singlefamily'"
								>
									<i class="fas fa-home" style="margin-right: .3em"></i>New
									Single-family Evaluation
								</div>
								<div
									v-if="
										$store.getters.session.rights.preferred &&
											$store.state.property.propertyType == 'Multifamily'
									"
									class="button is-primary "
									@click="$store.state.isNewMultifamilyEvaluationActive = true"
									style="margin-left: 10px"
								>
									<i class="fas fa-building" style="margin-right: .3em"></i>New
									Multi-family Evaluation
								</div>
							</div>

							<Evaluations />
						</b-tab-item>

						<b-tab-item label="Connections">
							<template slot="header">
								<span
									>Connections
									<b-tag rounded>{{ connectionCount() }}</b-tag></span
								>
							</template>
							<div class="column">
								<div
									class="button is-primary "
									@click="isConnectionSelectActive = true"
								>
									New Connection
								</div>
							</div>
							<Connections />
						</b-tab-item>

						<b-tab-item label="Notes">
							<template slot="header">
								<span
									>Notes <b-tag rounded>{{ noteCount() }}</b-tag></span
								>
							</template>
							<div class="column">
								<div class="button is-primary" @click="isNewNoteActive = true">
									New Note
								</div>
							</div>
							<Notes :propertyId="property_id" />
						</b-tab-item>

						<b-tab-item label="Documents">
							<template slot="header">
								<span
									>Documents <b-tag rounded>{{ documentCount() }}</b-tag></span
								>
							</template>
							<div class="column">
								<div
									class="button is-primary "
									@click="
										() => {
											$store.state.uploadPercentage = 0;
											$store.state.isAddDocumentsActive = true;
										}
									"
								>
									New Document
								</div>
							</div>
							<Documents />
						</b-tab-item>

						<!-- <b-tab-item label="Listings">
              <template slot="header">
                <span>Listings <b-tag rounded>{{ listingCount() }}</b-tag></span>
              </template>
              <div class="column">
                <div
                  class="button is-primary "
                  @click="newListing()"
                >
                  New Listing
                </div>
              </div>
              <Listings />
            </b-tab-item> -->

						<!-- <b-tab-item
              label="Applications"
              disabled
            >
              <template slot="header">
                <span>Applications <b-tag rounded>0</b-tag></span>
              </template>
            </b-tab-item>

            <b-tab-item
              label="Tenants"
              disabled
            >
              <template slot="header">
                <span>Tenants <b-tag rounded>0</b-tag></span>
              </template>
            </b-tab-item>

            <b-tab-item
              label="Payments"
              disabled
            >
              <template slot="header">
                <span>Payments <b-tag rounded>0</b-tag></span>
              </template>
            </b-tab-item> -->
					</b-tabs>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import Helpers from "@/services/Helpers.js";
import LiberatorService from "@/services/LiberatorService.js";
import Connections from "@/components/properties/details/Connections.vue";
import DealInfos from "@/components/properties/details/DealInfos.vue";
import Documents from "@/components/properties/details/Documents.vue";
import Evaluations from "@/components/properties/details/Evaluations.vue";
import Notes from "@/components/properties/details/Notes.vue";
import Stages from "@/components/properties/details/Stages.vue";
import NewNote from "@/components/properties/notes/NewNote.vue";
import ConnectionSelect from "@/components/connections/ConnectionSelect.vue";
import AddDocuments from "@/components/properties/documents/AddDocuments.vue";
import Listings from "@/components/properties/details/Listings.vue";
import ListingEditor from "@/components/properties/listings/ListingEditor";
import NewMultifamily from "@/components/properties/evaluations/multifamily/NewMultifamily.vue";
import EditMultifamilyPropertyAttributes from "@/components/properties/evaluations/EditMultifamilyPropertyAttributes.vue";

export default {
  components: {
    Connections,
    DealInfos,
    Documents,
    Evaluations,
    Notes,
    Stages,
    NewNote,
    ConnectionSelect,
    AddDocuments,
    Listings,
    ListingEditor,
    NewMultifamily,
    EditMultifamilyPropertyAttributes
  },

  methods: {
    editProperty() {
      console.log("editProperty()");
      this.$store.state.isEditMFFPropertyActive = true;
    },

    goToProperties() {
      this.$router.push({
        path: "/properties"
      });
    },

    stageStyle(stage) {
      return Helpers.getStageStyle(stage);
    },

    updateStage() {
      if (
        this.$store.state.property.id == undefined ||
        this.$store.state.property.stage == undefined
      )
        return;
      LiberatorService.updatePropertyStage(
        this.$store.state.property.id,
        this.$store.state.property.stage
      );
    },

    newListing() {
      console.log("newListing()", this.$store.state.property);
      this.$store.state.listing.attributes = [];

      this.$store.state.listing.attributes.applicationPolicy = "";
      this.$store.state.listing.attributes.availableDate = new Date();
      this.$store.state.listing.attributes.city = this.$store.state.property.city;
      this.$store.state.listing.attributes.depositPolicy = "";
      this.$store.state.listing.attributes.description = "";
      this.$store.state.listing.attributes.features = [];
      this.$store.state.listing.attributes.id = "";
      this.$store.state.listing.attributes.isActive = true;
      this.$store.state.listing.attributes.mapUrl = "";
      this.$store.state.listing.attributes.petPolicy = "";
      this.$store.state.listing.attributes.pictureUrls = [];
      this.$store.state.listing.attributes.rentPolicy = "";
      this.$store.state.listing.attributes.state = this.$store.state.property.state;
      this.$store.state.listing.attributes.street = this.$store.state.property.address;
      this.$store.state.listing.attributes.title = "";
      this.$store.state.listing.attributes.zip = this.$store.state.property.zip;

      if (this.$store.state.property.evaluations.length > 0) {
        this.$store.state.listing.attributes.beds = this.$store.state.property.evaluations[0].beds;
        this.$store.state.listing.attributes.baths = this.$store.state.property.evaluations[0].baths;
        this.$store.state.listing.attributes.sqft = this.$store.state.property.evaluations[0].sqft;
      } else {
        this.$store.state.listing.attributes.beds = 0;
        this.$store.state.listing.attributes.baths = 0;
        this.$store.state.listing.attributes.sqft = 0;
      }

      this.$store.state.listing.isNew = true;
      this.$store.state.listing.isActive = true;
    },

    newEvaluation() {
      this.$store
        .dispatch("newPropertyEvaluation", this.property_id)
        .then(async response => {
          console.log(response);
          await this.$router.push({
            name: "EvaluationDetails",
            params: {
              property_id: this.$store.state.property.id,
              evaluation_id: this.$store.state.evaluation.id
            }
          });
        })
        .catch(e => {
          this.showError(e);
        });
    },

    evaluationCount() {
      if (
        this.$store.state.property &&
        this.$store.state.property.evaluations
      ) {
        return this.$store.state.property.evaluations.length.toString();
      } else return 0;
    },

    connectionCount() {
      if (
        this.$store.state.property &&
        this.$store.state.property.connections
      ) {
        return this.$store.state.property.connections.length;
      } else return 0;
    },

    noteCount() {
      if (this.$store.state.property && this.$store.state.property.notes) {
        return this.$store.state.property.notes.length;
      } else return 0;
    },

    documentCount() {
      if (this.$store.state.property && this.$store.state.property.documents) {
        return this.$store.state.property.documents.length;
      } else return 0;
    },

    listingCount() {
      if (this.$store.state.property && this.$store.state.property.listings) {
        return this.$store.state.property.listings.length;
      } else return 0;
    }
  },

  props: ["property_id", "property: { type: Object, required: true }"],

  data() {
    return {
      note: "",
      isBusyPropertyDetails: true,
      isNewNoteActive: false,
      isListingEditorActive: false,
      isConnectionSelectActive: false,
      propertyId: "",
      activeTab: 0
    };
  },

  mounted() {
    this.$store.state.isNewMultifamilyEvaluationActive = false;
    this.$store.dispatch("getProperty", this.property_id);
    console.log("mounted()", this.$store.state.property);
  }
};
</script>

<style>
</style>
